import type { GamePhase } from "../types";

export const NEXT_PHASE: Readonly<Record<GamePhase, GamePhase | null>> = {
  ready: "draw",
  draw: "land",
  land: "supply",
  supply: "command",
  command: "battle",
  battle: "cleanup",
  cleanup: "ready",
  "action-window": null,
  finished: null,
};

export function getNextPhase(phase: GamePhase): GamePhase | null {
  return NEXT_PHASE[phase];
}
